import { t } from "i18next";

export const TopBanner = () => {
    return (
        <div
            className="top-banner"
            style={{
                padding: '15px',
                borderRadius: '15px',
                background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                width: '100%',
                display: "flex",
                gap: '15px',
                alignItems: "center",
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                flexWrap: "wrap",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
        >
            <span
                style={{
                    flex: 2,
                    minWidth: "200px",
                    fontSize: "1rem",
                    lineHeight: "1.6",
                    color: "#1a1a1a",
                }}
            >
                {t("topBannerText")}
            </span>

            <div
                style={{
                    flex: 1,
                    minWidth: "150px",
                    height: "auto",
                    aspectRatio: "8 / 3",
                    borderRadius: "10px",
                    overflow: "hidden",
                    position: "relative",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                }}
            >
                <video
                    src="https://portfoliom-blog.sirv.com/blog/1%20(online-video-cutter.com).mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block"
                    }}
                />
                {/* Hafif overlay */}
                <div style={{
                    position: "absolute",
                    top: 0, left: 0,
                    width: "100%",
                    height: "100%",
                    background: "linear-gradient(to bottom, rgba(0,0,0,0.15), rgba(0,0,0,0))"
                }} />
            </div>
        </div>
    );
};
